/**
 * @fileoverview Dias e horário de envio (de Brasília), usados pelo início
 * automático das Ordens de serviço e pelos Lembretes. Valor: { days, start, end },
 * com os dias no padrão do getDay (0 = domingo).
 */

import React from "react";
import TextField from "@material-ui/core/TextField";

import { i18n } from "../../../../translate/i18n";
import useStyles from "./styles";

const w = (key, params) => i18n.t(`triage.manager.editor.workOrders.${key}`, params);

// Segunda a domingo na tela.
const DIAS = [1, 2, 3, 4, 5, 6, 0];

const alternar = (lista, item) => (lista.includes(item) ? lista.filter((x) => x !== item) : [...lista, item]);

const SendWindowFields = ({ title, hint, value, onChange }) => {
  const classes = useStyles();
  return (
    <div className={classes.fieldsBox}>
      <div>
        <div className={classes.label}>{title}</div>
        <div className={classes.hint}>{hint}</div>
      </div>
      <div className={classes.dayRow} role="group" aria-label={w("days")}>
        {DIAS.map((d) => {
          const on = value.days.includes(d);
          return (
            <button
              key={d}
              type="button"
              aria-pressed={on}
              className={`${classes.dayBtn} ${on ? classes.dayBtnOn : ""}`}
              onClick={() => onChange({ days: alternar(value.days, d) })}
            >
              {w(`dayNames.d${d}`)}
            </button>
          );
        })}
      </div>
      <div className={classes.timeRow}>
        <TextField
          className={`${classes.field} ${classes.timeField}`}
          variant="outlined"
          size="small"
          type="time"
          label={w("from")}
          InputLabelProps={{ shrink: true }}
          value={value.start}
          onChange={(ev) => onChange({ start: ev.target.value })}
        />
        <TextField
          className={`${classes.field} ${classes.timeField}`}
          variant="outlined"
          size="small"
          type="time"
          label={w("to")}
          InputLabelProps={{ shrink: true }}
          value={value.end}
          onChange={(ev) => onChange({ end: ev.target.value })}
        />
      </div>
    </div>
  );
};

export default SendWindowFields;
